const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#3B6E8E',
                hover: '#3A6074'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
